import React, { ComponentProps } from 'react'
// Components
import Filters from 'components/Sportsmen/Filters'
import Table from 'components/Sportsmen/Table/Table'

interface Props {
  readonly table?: Pick<ComponentProps<typeof Table>, 'onSelect'>
  readonly filter?: Pick<ComponentProps<typeof Filters>, 'selectedId'>
}

const ModalFilter: React.FC<Props> = (p) => (
  <>
    <Filters {...p.filter} />
    <Table {...p.table} />
  </>
)

export default ModalFilter
